import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconShipmentDone from '@/icons/ShipmentDone.svg';

export const ArticleRecyclingDestinationReachedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_recycling_destination_reached'>;
  displayArticleName: boolean;
}) => {
  return (
    <BaseActivity
      key={activity.id}
      createdAt={activity.createdAt}
      icon={<IconShipmentDone />}
      type="primary"
      message={
        <BaseActivityText>
          <Trans id="activities.article_recycling_destination_reached.message">
            The item{' '}
            <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />{' '}
            has reached its recycling destination
          </Trans>
        </BaseActivityText>
      }
    />
  );
};
